const API_BASE = "https://ecomapi.asherjewels.com.ph/apiecom";

async function fetchAuthJson(path, options = {}) {
  const response = await fetch(`${API_BASE}/${path}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok && !payload) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return payload || { status: "error", message: "Unexpected server response." };
}

export async function loginRequest(loginId, password) {
  return fetchAuthJson("login.php", {
    method: "POST",
    body: JSON.stringify({ username: loginId, password }),
  });
}

export async function registerRequest(data) {
  return fetchAuthJson("register_user.php", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function forgotPasswordRequest(email) {
  return fetchAuthJson("forgot_password.php", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
}

export async function resetPasswordRequest(token, newPassword, confirmPassword) {
  return fetchAuthJson("reset_password.php", {
    method: "POST",
    body: JSON.stringify({ token, new_password: newPassword, confirm_password: confirmPassword }),
  });
}

export async function logoutRequest() {
  return fetchAuthJson("logout.php", { method: "POST" });
}

export async function sessionCheckRequest() {
  return fetchAuthJson("session_check.php", { method: "GET" });
}

export async function socialProvidersRequest() {
  return fetchAuthJson("social_providers.php", { method: "GET" });
}

export async function updateAccountRequest(data) {
  return fetchAuthJson("update_account.php", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function changePasswordRequest(data) {
  return fetchAuthJson("change_password.php", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function getOrdersRequest() {
  return fetchAuthJson("get_orders.php", { method: "GET" });
}

export { API_BASE };
